import { createAction, props } from "@ngrx/store";

export const rejectAssociatedProjects = createAction(
  'Account.RejectAssociatedProjects',
  props<{ error: unknown }>()
);
